function Hero() {
    return (
        <section >
            <h1>Luan William</h1>
            <p>Sou uma pessoa curiosa, criativa e sempre em busca de evolução,
                tanto pessoal quanto profissional. Tenho grande interesse por tecnologia, especialmente na área de
                desenvolvimento, onde gosto de explorar novas ferramentas e criar soluções.</p>
            <p>
                Fora do ambiente técnico, valorizo bastante a cultura e a criatividade no dia a dia.
                Nos fins de semana, gosto de jogar basquete, o que me ajuda a manter disciplina, foco e
                trabalho em equipe. Também tenho grande interesse por cultura em geral, frequentando museus,
                assistindo filmes e acompanhando referências de moda, que influenciam minha forma de pensar e meu estilo.
            </p>
            <p>
                Sou alguém que aprecia aprender constantemente, trocar ideias e buscar novas referências,
                tanto na tecnologia quanto no universo cultural.
            </p>
        </section>
    )
}

export default Hero
